import {
  FunctionComponent as F,
  useEffect,
  useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IState } from '../../core/store/store';
import { Box, Typography } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import TextTooltip from '../UI/Tooltip/TextTooltip';
import { postOrderReminder as postUserOrderReminder } from '../../core/http/user';
import { postOrderReminderActive as postProtocolOrderReminderActive } from '../../core/http/protocol';
import { updateOrderReminder as updateProtocolOrderReminder } from '../../core/store/protocol/protocol.slice';
import OrderReminder from '../Account/OrderReminder';
import { updateOrderReminder as updateUserOrderReminder } from '../../core/store/user/user.slice';
import IconPopper from '../UI/Button/IconPopper';


interface Props
{
  protocolId: number
}


const ProtocolOrderReminder: F<Props> = (props: Props) =>
{
  const dispatch = useDispatch();

  const protocolOrderReminderActive = Boolean(useSelector((state: IState) => state.protocol.protocols
    .find(p => p.protocolId === props.protocolId)?.orderReminderActive));
  const userOrderReminder = useSelector((state: IState) => state.user.orderReminder);
  const userId = useSelector((state: IState) => state.user.userId);

  const [active, setActive] = useState<boolean>(
    protocolOrderReminderActive &&
    Boolean(userOrderReminder.active));
  const [popperOpen, setPopperOpen] = useState(false);

  useEffect(() => setActive(protocolOrderReminderActive && Boolean(userOrderReminder.active)));

  const activateOrderReminder = () =>
  {
    setActive(true);

    if(!userOrderReminder.active)
    {
      dispatch(updateUserOrderReminder({ active: true }));
      postUserOrderReminder({ active: true });
    }

    if(!protocolOrderReminderActive)
    {
      dispatch(updateProtocolOrderReminder({ protocolId: props.protocolId, orderReminder: true }));
      postProtocolOrderReminderActive(props.protocolId, true);
    }
  }

  const protocolOrderRemindersActive = useSelector((state: IState) => state.protocol.protocols
    .filter(p => p.userId === userId)
    .map(p => p.orderReminderActive));

  const deactivateOrderReminder = () =>
  {
    setActive(false);

    // Reads store at button click time

    // If last protocol order reminder, also turn off order reminders for user
    if(protocolOrderRemindersActive.filter(r => r).length <= 1)
    {
      dispatch(updateUserOrderReminder({ active: false }));
      postUserOrderReminder({ active: false });
    }

    dispatch(updateProtocolOrderReminder({ protocolId: props.protocolId, orderReminder: false }));
    postProtocolOrderReminderActive(props.protocolId, false);
  }

  const handleClick = () =>
  {
    // Turning off
    if(active)
    {
      deactivateOrderReminder();
      setPopperOpen(false);
      return { preventDefault: true };
    }

    // Turning on
    activateOrderReminder();

    if(userOrderReminder.active)
      return { preventDefault: true };
  }

  return (
    <IconPopper
      Content={
        <>
          <Typography variant='body2' fontWeight='bold'>
            Choose a date and frequency
          </Typography>
          <Box sx={{ height: 25 }}/>
          <OrderReminder />
        </>}
      Icon={
        active ?
          <TextTooltip lines={["Order reminder emails active"]} tooltipPlacement='top-end'>
            <NotificationsActiveIcon fontSize='large' sx={{ color: 'gray', cursor: 'pointer' }}/>
          </TextTooltip> :
          <TextTooltip lines={["Turn on order reminder emails for this protocol"]} tooltipPlacement='top-end'>
            <NotificationsIcon fontSize='large' sx={{ color: 'lightGray', cursor: 'pointer' }}/>
          </TextTooltip>}
      handleIconClick={handleClick}
      state={[popperOpen, setPopperOpen]}/>);
};

export default ProtocolOrderReminder;